import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { FeatureFlagsService } from '../../../core/services/feature-flags.service';
import { PlanWeekDialogComponent } from '../../plan-week/plan-week-dialog.component';
import { SmartBookDialogComponent } from './smart-book-dialog.component';

/** The PostHog flag behind Louis's This week on Home; with it on, every entry point opens Plan my week. */
export const PLAN_WEEK_FLAG = 'home-workspace-week';

/**
 * im-quick-book-dialog — the week planner the app shell mounts, whichever it is.
 *
 * RESPONSIBILITY
 *   Every entry point opens the week planner through QuickBookService (⌘B, ⌘K, the tray, the widgets, Bookings,
 *   the schedule's day menu, This week). Nath (4 Oct, P3): with `home-workspace-week` on they all open Louis's
 *   planner, Plan my week (shared/plan-week), and Smart Book's dialog retires for those people. Everyone else
 *   keeps Smart Book (`im-smart-book-dialog`) until the flag is on for all.
 *
 *   The planner is loaded only for people who get it (`@defer`), so Smart Book's people download none of it. A
 *   planner asked for before its code arrives opens as soon as it does: it reads QuickBookService's open state when
 *   it is created.
 *
 * USED BY  AppShellComponent (the one mount). The shell is not this lane's to change, so the selector and the
 *   class name stay what it imports.
 */
@Component({
  selector: 'im-quick-book-dialog',
  standalone: true,
  imports: [PlanWeekDialogComponent, SmartBookDialogComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (planner()) {
      @defer (on immediate) { <im-plan-week-dialog /> }
    } @else {
      <im-smart-book-dialog />
    }
  `,
  styles: ':host { display: contents; }',
})
export class QuickBookDialogComponent {
  private readonly flags = inject(FeatureFlagsService);
  protected readonly planner = computed(() => this.flags.flagEnabled(PLAN_WEEK_FLAG));
}
